class BESSAppMapLocation extends BESSAppComponent {

    constructor() {
        super('.app-map-location');
    }


    initialise(node) {
        if (this.isPresent(node)) {
            BESSApp.instance.requireGoogleMaps(function () {
                this.doInitialise(node);
            }.bind(this));
        }
    }

    setupComponent(componentNode) {
        let data = componentNode.data('location');

        let latlng = new google.maps.LatLng(
            data.lat,
            data.lng);

        BESSSetupMapComponent(componentNode, latlng);
    }

    static updateMapLocation(componentNode, lat, lng) {
        let googleMap = componentNode.data('googleMap');
        let marker = componentNode.data('marker');

        marker.setMap(null);

        let latlng = new google.maps.LatLng(
            lat,
            lng);

        marker = new google.maps.Marker({
            position: latlng,
            map: googleMap,
            draggable: false
        });
        googleMap.setCenter(latlng);
        componentNode.data('marker', marker);
    }

    static createMap(componentNode, lat, lng) {
        let latlng = new google.maps.LatLng(
            lat,
            lng);
        return BESSSetupMapComponent(componentNode, latlng);
    }
}